import { render } from "./WarehouseSOH.vue?vue&type=template&id=0f521faa"
import script from "./WarehouseSOH.vue?vue&type=script&lang=js"
export * from "./WarehouseSOH.vue?vue&type=script&lang=js"

import exportComponent from "/home/collin/workspace/hitech05/main-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__